import React from 'react';

 const Span=()=>{

	return(
		<div style={{marginBottom:'5vh'}}>
			<span  style={{borderStyle: "solid", borderBottomWidth: "2px", borderColor: "rgb(210, 209, 217)", width: "50px", float: "left"}}></span>
		</div>
	)
}

export default Span;


// WEBPACK FOOTER //
// ./src/component/Span.js